.editActions {
  gap: 8px;
  margin-top: 16px;
  justify-content: flex-end;
}

.infoGrid {
  display: grid;
  align-items: center;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
}

.avatarRow {
  justify-content: flex-end;
}

.locationSection {
  margin-top: 16px;
}

.locationText {
  margin-bottom: 8px;
}

.mapContainer {
  width: 100%;
  height: 300px;
  border: 1px solid;
  border-color: var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  overflow: hidden;
}

.mapIframe {
  border: 0;
}
